import React, { Fragment, Suspense, lazy, useCallback, useState } from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const YouTube = lazy(() => import('react-youtube'));
import { LAZY } from '@yme/common/constants';
import { useWindowSize } from '@yme/hooks/index';
import { HERO_SECTION_YOUTUBE_PROPS, YOUTUBE_VIDEO_STATUS } from './constants';
import { HeroIframeWrapperStyled } from './styled';
export function HeroSectionYoutube({ videoId, preview, startTime = 0 }) {
    const [isYoutubeLoaded, setIsYoutubeLoaded] = useState(false);
    const [videoDuration, setVideoDuration] = useState(0);
    const { isLargeDesktopView } = useWindowSize();
    const videoStartTime = startTime > videoDuration ? 0 : startTime;
    const opts = {
        playerVars: {
            ...HERO_SECTION_YOUTUBE_PROPS,
            playlist: videoId,
            start: videoStartTime,
        },
    };
    const stateChangeHandler = useCallback((event) => {
        const playerState = event.target.getPlayerState();
        if (playerState === YOUTUBE_VIDEO_STATUS.readyToPlay) {
            setIsYoutubeLoaded(true);
        }
        if (playerState === YOUTUBE_VIDEO_STATUS.buffering) {
            setIsYoutubeLoaded(false);
        }
    }, []);
    const onError = useCallback(() => {
        setIsYoutubeLoaded(false);
    }, []);
    const onReady = useCallback((event) => {
        const youtubeIframeDefaultId = 'widget2';
        const iframe = document.getElementById(youtubeIframeDefaultId);
        const duration = event.target.getDuration();
        if (videoDuration === 0) {
            setVideoDuration(duration);
        }
        return iframe && iframe.setAttribute('tabindex', '-1');
    }, [videoDuration]);
    const onEnd = useCallback((event) => {
        event?.target?.loadPlaylist(videoId, 0, videoStartTime);
        event?.target?.playVideo();
    }, [videoId, videoStartTime]);
    return (React.createElement(HeroIframeWrapperStyled, { preview: preview, isLargeDesktopView: isLargeDesktopView, show: isYoutubeLoaded },
        React.createElement(Suspense, { fallback: Fragment },
            React.createElement(YouTube, { videoId: videoId, opts: opts, onStateChange: stateChangeHandler, onError: onError, onReady: onReady, onEnd: onEnd, loading: LAZY }))));
}
